import React from 'react';

import {Link, NavLink} from "react-router-dom";
import {RoutesMenu} from "./routes.js";
import {useUser} from "../../store/providers/app";

const Sidebar = () => {

    const { user } = useUser()

    return (
        <nav className="position-absolute top-0 w-100" style={{marginTop: "5rem"}}>
            <ul className="nav nav-pills nav-sidebar flex-column nav-child-indent p-2" role="menu">
                {RoutesMenu.filter(route => route.auth.includes(user.profile)).map((item, index) => {
                    return <li key={index} className="nav-item">
                        {item.subMenu ?
                            <Link
                                to={item.path}
                                className="nav-link"
                                data-bs-toggle="collapse"
                                role="button"
                                aria-expanded="false"
                                aria-controls={item.id}
                            >
                                <i className={`nav-icon ${item.icon} fs-3`}/>
                                <p className="align-text-bottom">
                                    {item.name}
                                    {item.subMenu && <i className="bi bi-chevron-down right"/>}
                                </p>
                            </Link>
                            :
                            <NavLink
                                to={item.path}
                                className="nav-link"
                            >
                                <i className={`nav-icon ${item.icon} fs-3`}/>
                                <p className="align-text-bottom">
                                    {item.name}
                                </p>
                            </NavLink>
                        }
                        {item.subMenu &&
                            <ul className="collapse nav nav-custom" id={item.id} data-bs-parent="#menu">
                                {item.subMenu?.filter(route => route.auth.includes(user.profile)).map((item, index) => {
                                    return <li key={index} className="nav-item w-100">
                                        <NavLink
                                            to={item.path}
                                            className="nav-link"
                                        >
                                            <i className={`nav-icon ${item.icon}`}/>
                                            <p className="align-text-bottom">{item.name}</p>
                                        </NavLink>
                                    </li>
                                })}
                            </ul>
                        }
                    </li>
                })}
            </ul>
        </nav>
    )
}

export default Sidebar;
